import React, { useEffect, useState } from "react";
import './AdminDashboard.css';
import DashboardCard from "./DashboardCard";
import {
    Baby,
    BookOpen,
    Database,
    FileQuestion,
    GraduationCap,
    LayoutDashboard,
    LoaderIcon,
    Medal,
    UserCog,
    UserPen,
    Users,
    MedalIcon,
    Eye,
    FileText,
    Download
} from 'lucide-react';

import api from '../api/axiosConfig';

const AdminDashboard = () => {
    const [dashboardData, setDashboardData] = useState(null);

    useEffect(() => {
        fetchDasboardData();
    }, []);

    const fetchDasboardData = async () => {
        try {
            const { data } = await api.get('/admin/dashboard-data'); // Make sure you have a GET route in your backend!
            setDashboardData(data);
        } catch (err) { console.error("Error fetching dashboard data"); }
    };
    return (
        <div>
            <h2 style={{ marginBottom: '1.5rem' }}>Dashboard</h2>
            {dashboardData && (<div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
                    <DashboardCard
                        icon={Users}
                        title={dashboardData['users']['title']}
                        value={dashboardData['users']['value']}
                    />
                    <DashboardCard
                        icon={UserCog}
                        title={dashboardData['admins']['title']}
                        value={dashboardData['admins']['value']}
                    />
                    <DashboardCard
                        icon={UserPen}
                        title={dashboardData['parents']['title']}
                        value={dashboardData['parents']['value']}
                    />
                    <DashboardCard
                        icon={Baby}
                        title={dashboardData['students']['title']}
                        value={dashboardData['students']['value']}
                    />
                </div>
                <br />
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
                    <DashboardCard
                        icon={GraduationCap}
                        title={dashboardData['grades']['title']}
                        value={dashboardData['grades']['value']}
                    />
                    <DashboardCard
                        icon={BookOpen}
                        title={dashboardData['subjects']['title']}
                        value={dashboardData['subjects']['value']}
                    />
                    <DashboardCard
                        icon={LayoutDashboard}
                        title={dashboardData['topics']['title']}
                        value={dashboardData['topics']['value']}
                    />
                    <DashboardCard
                        icon={Database}
                        title={dashboardData['questions']['title']}
                        value={dashboardData['questions']['value']}
                    />
                    <DashboardCard
                        icon={Eye}
                        title={dashboardData['unreviewed_questions']['title']}
                        value={dashboardData['unreviewed_questions']['value']}
                    />

                </div>
                <br />
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
                    <DashboardCard
                        icon={FileQuestion}
                        title={dashboardData['quizzes']['title']}
                        value={dashboardData['quizzes']['value']}
                    />
                    <DashboardCard
                        icon={Medal}
                        title={dashboardData['badges']['title']}
                        value={dashboardData['badges']['value']}
                    />
                    <DashboardCard
                        icon={MedalIcon}
                        title={dashboardData['badges_awarded']['title']}
                        value={dashboardData['badges_awarded']['value']}
                    />
                </div>
                <br />
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem' }}>
                    <DashboardCard
                        icon={FileText}
                        title={dashboardData['printables']['title']}
                        value={dashboardData['printables']['value']}
                    />
                    <DashboardCard
                        icon={Download}
                        title={dashboardData['printable_downloads']['title']}
                        value={dashboardData['printable_downloads']['value']}
                    />
                </div>
            </div>)}
            {!dashboardData && (<LoaderIcon />)}
        </div>
    );
}

export default AdminDashboard;